import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import CryptoJS from 'crypto-js';

import Axios from '../../../services/AxiosInstance';
import { useFormik } from "formik";
import { makeStyles } from '@mui/styles';
import { newBusinessSchema } from "./newBusinessSchema";


const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#348cd4',
    },
}));
const AddNewRegistration = () => {
    const classes = useStyles();
    const [loader, setLoader] = useState({ isOpen: false, isData: '' });
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })
    const Navigate = useNavigate();
    // useEffect(() => {
    //     const auth = localStorage.getItem('token');
    // })

    const callSignUpApi = async (values) => {
        console.log(values);
        // const encryptedPassword = CryptoJS.AES.encrypt(values.password, process.env.REACT_APP_login_key).toString();
        Axios
            .post("api/bussiness/add-new-business", {
                business_name: values.businessName,
                business_contact_person: values.name,
                business_email_id: values.email,
                business_mobile_no: values.phoneNum,
                country_id: "20",
                business_website: values.businessWebsite,
                password: values.password,
                description: "",
                state_id: "",
                district_id: "",
                city_name: "",
                address: "asassd",
                business_type_id: "12"
            }, setLoader({ isOpen: true }))
            .then((response) => {
                setLoader({ isOpen: false })
                console.log(response);
                if (response.data.code === "success") {
                    setNotify({
                        isOpen: true,
                        messsage: "Business Created SuccessFully",
                        type: 'success'
                    });
                }
            }).catch((err) => {
                setLoader({ isOpen: false })
                console.log(err);
                if (err?.response?.data?.message === "Registeration Mobile No already exist") {
                    setNotify({
                        isOpen: true,
                        messsage: "Registeration Mobile No. already exist",
                        type: 'error'
                    });
                }
            });
    }

    const { handleSubmit, values, handleChange, errors, handleBlur, touched } = useFormik({
        initialValues: {
            businessName: "",
            businessWebsite: "",
            name: "",
            email: "",
            phoneNum: "",
            description: "",
            password: "",
            confirm_password: "",
            isAgree: false

        },
        onSubmit: callSignUpApi,
        validationSchema: newBusinessSchema

    });

    return (
        <>
            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <h4 className="page-title">Add New Business</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-lg-6 col-xl-6">
                                <div className="card bg-pattern rigister-form">

                                    <div className="card-div p-4">

                                        <div className="text-center w-75 m-auto admin_lg ">
                                            <h5 className="text-uppercase text-center font-bold mt-4">Register Now</h5>
                                        </div>


                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group mb-3 rigister-colm">
                                                <label htmlFor="business-name">Business Name</label>
                                                <input onChange={handleChange} name="businessName" id="business-name"
                                                    maxLength={51}
                                                    value={values.businessName} type="text" onBlur={handleBlur}
                                                    className="form-control" placeholder="Enter Business name" />
                                                {touched.businessName && errors.businessName && (<div className="invalid-input">
                                                    {errors.businessName}</div>)}


                                            </div>


                                            <div className="form-group mb-3 rigister-colm">
                                                <label htmlFor="busines-website">Business Website</label>
                                                <input onChange={handleChange} name="businessWebsite" id="busines-website"
                                                    maxLength={201}
                                                    value={values.businessWebsite} type="text" onBlur={handleBlur}
                                                    className="form-control" placeholder="Business Website" />
                                                {touched.businessWebsite && errors.businessWebsite && (<div
                                                    className="invalid-input">{errors.businessWebsite}</div>)}


                                            </div>

                                            <div className="form-group mb-3 rigister-colm">
                                                <label htmlFor="your-name">Your Name</label>
                                                <input onChange={handleChange} name="name" id="your-name" value={values.name}
                                                    maxLength={41}
                                                    type="text" onBlur={handleBlur} className="form-control"
                                                    placeholder="Your Name" />
                                                {touched.name && errors.name && (<div className="invalid-input">{errors.name}</div>
                                                )}



                                            </div>


                                            <div className="form-group mb-3 rigister-colm">
                                                <label htmlFor="email-address">Your Email</label>
                                                <input onChange={handleChange} name="email" id="email-address" value={values.email}
                                                    maxLength={101}
                                                    type="email" onBlur={handleBlur} className="form-control"
                                                    placeholder="Enter Email Address" />
                                                {touched.email && errors.email && (<div className="invalid-input">{errors.email}
                                                </div>)}



                                            </div>


                                            <div className="form-group mb-3 rigister-phn">
                                                <label htmlFor="phone-number">Your Phone Number</label>
                                                <input onChange={handleChange} name="phoneNum" id="phone-number"
                                                    maxLength={11}
                                                    value={values.phoneNum} type="tel" onBlur={handleBlur} className="form-control"
                                                    placeholder="Enter Phone Number" />
                                                {touched.phoneNum && errors.phoneNum && (<div className="invalid-input">
                                                    {errors.phoneNum}</div>)}



                                            </div>

                                            <div className="form-group mb-3 rigister-colm">
                                                <label htmlFor="new-password">New Password </label>
                                                <input
                                                    id="new-password"
                                                    maxLength={21}
                                                    onChange={handleChange}
                                                    name="password"
                                                    onBlur={handleBlur}
                                                    type="password"
                                                    placeholder="Enter Your Password"
                                                    value={values.password}
                                                    className="form-control"
                                                />
                                                {touched.password && errors.password && (<div className="invalid-input">
                                                    {errors.password}</div>)}
                                            </div>



                                            <div className="form-group mb-3 rigister-colm">

                                                <label>Confirm Password </label>
                                                <input
                                                    type="password"
                                                    onChange={handleChange}
                                                    maxLength={21}
                                                    name="confirm_password"
                                                    onBlur={handleBlur}
                                                    value={values.confirm_password}
                                                    className="form-control"
                                                    placeholder="Confirm Your Password"
                                                />
                                                {touched.confirm_password && errors.confirm_password && (<div className="invalid-input">
                                                    {errors.confirm_password}</div>)}

                                            </div>



                                            <div className="form-group mb-3 rigister-textarea">

                                                <label htmlFor="discription">Description</label>
                                                <textarea onChange={handleChange} name="description" id="discription"
                                                    maxLength={501}
                                                    value={values.description} type="text" className="form-control"
                                                    placeholder="Write something about your business in 250 words" />
                                            </div>


                                            <div className="form-group">
                                                <div className="custom-control custom-checkbox checkbox-success">
                                                    <input onChange={handleChange} name="isAgree" value={values.isAgree}
                                                        type="checkbox" onBlur={handleBlur} className="custom-control-input"
                                                        id="checkbox-signup" />

                                                    <label className="custom-control-label" htmlFor="checkbox-signup">I accept <a
                                                        className="text-dark">Terms and
                                                        Conditions</a></label>
                                                </div>
                                                {touched.isAgree && errors.isAgree && (<div className="invalid-input">
                                                    {errors.isAgree}</div>)}

                                            </div>



                                            <div className="form-group mb-0 text-center">
                                                <button className="btn btn-gradient btn-block" type="submit"> Sign Up  </button>
                                            </div>

                                        </form>

                                        <div className="row mt-4">
                                            <div className="col-sm-12 text-center">
                                                {/* <p className="text-muted mb-0">Already have an account? <Link to="/login"
                                                    className="text-dark ml-1"><b>Sign In</b></Link></p> */}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- end card-div --> */}
                                </div>
                                {/* <!-- end card --> */}

                            </div>
                            {/* <!-- end col --> */}
                        </div>
                        {/* <!-- end row --> */}
                    </div>
                    {/* <!-- end container --> */}
                </div>
                {/* <!-- end page --> */}

                {/* <!-- Vendor js --> */}
                {/* 
                {
                    notify.isOpen ?
                        <Notification
                            notify={notify}
                            setNotify={setNotify} />
                        : ""
                }
                {loader.isOpen ?
                    <Backdrop className={classes.backdrop} open>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    : ""} */}

            </div>

        </>
    )

}

export default AddNewRegistration;